import React from 'react';

export default function Lobby({ gameState, roomCode, playerId, onLeave }) {
  if (!gameState) {
    return (
      <div className="lobby">
        <div className="room-code-display">
          <div className="label">Room Code</div>
          <div className="code">{roomCode}</div>
        </div>
        <div className="waiting-state">
          <div className="waiting-icon">{'\u231B'}</div>
          Connecting to game...
        </div>
      </div>
    );
  }

  const myName = playerId && gameState.players?.find(p => p.id === playerId)?.name;

  return (
    <div className="lobby">
      {myName && (
        <div className="playing-as-banner">
          Playing as: <strong>{myName}</strong>
        </div>
      )}
      <div className="room-code-display">
        <div className="label">Room Code</div>
        <div className="code">{gameState.roomCode || roomCode}</div>
      </div>

      <div className="card">
        <div className="card-header">
          Players ({gameState.playerCount})
        </div>
        <ul className="player-list">
          {gameState.players.map((p) => (
            <li key={p.id} className="player-item">
              <span className="player-name">{p.name}</span>
              <span className="player-status">
                <span className={`connected-dot ${p.connected ? '' : 'disconnected'}`} />
                {p.connected ? 'Ready' : 'Disconnected'}
              </span>
            </li>
          ))}
        </ul>
        {gameState.playerCount < 5 && (
          <div className="info-box mt-8">
            Need at least 5 players to start ({5 - gameState.playerCount} more)
          </div>
        )}
      </div>

      <div className="waiting-state">
        <div className="waiting-icon">{'\u231B'}</div>
        Waiting for moderator to start the game...
      </div>

      {onLeave && (
        <button
          className="btn btn-secondary btn-full mt-8"
          onClick={() => {
            if (window.confirm('Leave this game?')) {
              onLeave();
            }
          }}
        >
          Leave Game
        </button>
      )}
    </div>
  );
}
